import template from './detalles.html';
import { FormActions } from 'core/services/form';
import detallesI18N from 'i18n/citas/es.json';
import { fechaHoraRenderer } from 'core/util';
import { formatErrorMessage } from 'core/util';

export let DetallesComponent = {
  templateUrl: template,
  selector: 'citasDetallesList',
  bindings: {
    translations: '='
  },
  controller: DetallesCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(detallesI18N).concat(commonsI18N);

DetallesCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService'
];

function DetallesCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService) {

  var defaultColumnOrder = ['cabecera.numero', 'cabecera.cliente.razonSocial', 'servicio.nombre', 'especialista.nombre', 'especialista.apellido', 'fechaInicio'];

  BasicFactory.setup('citas');

  this.options = {
    resource: 'cita-detalles',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de detalles'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'cabecera.numero', title: this.translations['Número Cita'], name: 'cita.numero' },
      { data: 'cabecera.cliente.razonSocial', title: this.translations['Cliente'], name: 'cita.cliente.razonSocial' },
      { data: 'servicio.nombre', title: this.translations['Servicio'] },
      { data: 'especialista.nombre', title: this.translations['Nombre Especialista'] },
      { data: 'especialista.apellido', title: this.translations['Apellido Especialista'] },
      { data: 'fechaInicio', title: this.translations['Fecha'], renderWith: fechaHoraRenderer, type: 'date-range' },
      { data: 'duracion', title: this.translations['Duración'] }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: () => { false; },
    onRemove: () => { false; },
    onView: () => { false; },
    canEditCondition: () => { false; },
    canListCondition: () => { false; },
    canRemoveCondition: () => { false; },
    canView: canView.bind(this),
    canEdit: canEdit.bind(this),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-info btn-dt" uib-tooltip="' + this.translations['Ver cita'] + '" ng-show="options.canView(rowsData[<%= dataId %>])" ng-click="view(rowsData[<%= dataId %>])"> <span class="glyphicon glyphicon-eye-open"></span></button>',
        functionName: 'view',
        functionDef: (data) => {
          $state.go('home.citas.uid.view', { uid: data.cabecera.id });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-success btn-dt" uib-tooltip="' + this.translations['Editar cita'] + '" ng-show="options.canEdit(rowsData[<%= dataId %>])" ng-click="edit(rowsData[<%= dataId %>])"> <span class="glyphicon glyphicon-pencil"></span></button>',
        functionName: 'edit',
        functionDef: (data) => {
          $state.go('home.citas.uid.edit', { uid: data.cabecera.id });
        }
      }
    ]
  };

  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);

  function canView(data) {
    return AuthorizationService.hasPermission('update_citas');
  }

  function canEdit(data) {
    return (data.cabecera.estado.value === 'No Confirmada') && AuthorizationService.hasPermission('update_citas');
  }

  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de detalles de citas']
    };
    this.form();
  };

  function mapStateToThis(state) {

    this.handleStatus(state);
    return { form: state.form };
  }

  function handleStatus(state) {
    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/citas/detalles-list/detalles.component.js